import { render } from "./HeaderExpositorSection.vue?vue&type=template&id=18810f1a"
import script from "./HeaderExpositorSection.vue?vue&type=script&lang=js"
export * from "./HeaderExpositorSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__